import {view} from '@sail/ui';

type Props = {
  position?: 'center' | 'start' | 'end';
  children: React.ReactNode;
};

export const ChatRowContainer = ({
  position = 'start',
  children,
}: Props): JSX.Element => (
  <view.div
    data-testid="chat-row-container"
    css={{
      stack: 'x',
      alignX: position,
      gap: 'small',
    }}
  >
    {children}
  </view.div>
);
